import { X } from '../../../assets/svg';
import { PayoutTier } from '../../../types/location.types';
// Direct file imports on purpose - the styles barrel triggers a circular init.
import { Div, Icon } from '../../../styles/styles';
import { P } from '../../../styles/text';
import { lightTheme } from '../../../styles/theme';
import { TIER_RULE_ALLOWANCE } from '../payoutProviderRules';
import { MoneyInput, PercentageInput } from './PayoutNumberInputs';
import { ProviderRulesSection } from './ProviderRulesSection';
import { GroupCard } from './payoutSections.styled';

type Props = {
  tier: PayoutTier;
  index: number;
  onChange: (patch: Partial<PayoutTier>) => void;
  onRemove: () => void;
  /** Exceptions are a vGrubs-only feature, see `serviceSupportsProviderRules`. */
  showProviderRules?: boolean;
  disabled?: boolean;
};

/**
 * One base-amount window of a hybrid config, with its own exceptions. Drawn
 * as a bounded card so the exceptions nested inside it can't be mistaken for
 * a sibling of the rule.
 */
export const TierRow = ({
  tier,
  index,
  onChange,
  onRemove,
  showProviderRules,
  disabled,
}: Props) => (
  <GroupCard>
    <Div $flex $alignCenter $between>
      <P $bold $m="0">
        Rule {index + 1}
      </P>
      {!disabled && (
        <Icon $pointer $size="12" onClick={onRemove}>
          <X fill={lightTheme.darkGray} />
        </Icon>
      )}
    </Div>

    <Div $flex $columnSM $gap="12px">
      <MoneyInput
        label="Order Amount From"
        value={tier.minAmount}
        onChange={(cents) => onChange({ minAmount: cents ?? 0 })}
        disabled={disabled}
      />
      <MoneyInput
        label="Order Amount To"
        placeholder="No limit"
        value={tier.maxAmount}
        onChange={(cents) => onChange({ maxAmount: cents })}
        disabled={disabled}
      />
    </Div>

    <Div $flex $columnSM $gap="12px">
      <PercentageInput
        label="Bracket Percentage"
        value={tier.percentage}
        onChange={(percentage) => onChange({ percentage })}
        disabled={disabled}
      />
      <MoneyInput
        label="vGrubs Flat Fee"
        value={tier.flatFee}
        onChange={(flatFee) => onChange({ flatFee })}
        disabled={disabled}
      />
    </Div>

    {showProviderRules && (
      <ProviderRulesSection
        nested
        rules={tier.providerRules}
        allow={TIER_RULE_ALLOWANCE}
        disabled={disabled}
        onChange={(providerRules) => onChange({ providerRules })}
      />
    )}
  </GroupCard>
);
